export const defaultTemplate = {
  title: `タイトル: 【サンプル】スカウト用テンプレート`,
  text: `【◎◎◎の案内/＜※ アピールポイントを記載（本選考直結！など）＞】

 初めまして。株式会社◎◎の人事担当◎◎です。

 プロフィールを拝見し、＜※所属情報・ガクチカ・自己PRなどから抜粋（なぜあなたなのか？を記入）＞ のご経験に惹かれ、連絡いたしました。
 現在弊社では ＜※ 募集概要 / 募集背景などを記入（なぜ声をかけたか？を記入）＞ を募集しており、ぜひお話しの機会をいただきたく思います。

 もしよろしければ、以下URLよりお申し込みいただけますと幸いです。
 ＜※ カジュアル面談などで障壁を下げましょう！＞

 ▼ 日程調整はこちら
 ＜※ 日程調整ツールやイベントページのURLを記載（受け手がアクションしやすいように！）＞

 以下、長文となりますが弊社について簡単に紹介させてください。
 ーーー
 ＜※ 会社概要を記入（魅力を要約して伝えましょう！）＞
 ＜※ 記事やメディア掲載URLなどがあれば記入（理解度の向上に繋がります！）＞
 ーーー
 以上でございます。

 この度は弊社オファーをご覧いただき、誠にありがとうございます。
 もしお会いできましたら、弊社の業務内容や働き方について詳細にお伝えできればと思います。
 ご返信を心よりお待ちしています。

 ＜※ 署名を記入（誠実さが増します！）＞`
};
